import { useTranslation } from "react-i18next";
import eulogo from "../../resources/img/eulogo.png";
import { useContext, useState } from "react";
import InitContext from "../pages/InitContext";
import impressum from "../../resources/pdf/impressum.pdf";
import dataProtection from "../../resources/pdf/data_protection.pdf";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useMmcService from "../../services/MmcService";

const AppFooter = () => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);
  const [showChanges, setShowChanges] = useState(false);

  /*const urlFeedback =
    "https://surveys.questionpro.com/a/TakeSurvey?tt=GatwZDf0Z5zvrBJI8xMXglwYH%2BG%2Btzb%2B";*/

  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const [isSendingFeedback, setIsSendingFeedback] = useState(false);
  const [feedbackError, setFeedbackError] = useState("");

  const {
    clearError,
    sendFeedback,
  } = useMmcService();

  const handleSaveFeedback = async () => {
    if (!feedbackText.trim() || isSendingFeedback) {
      return;
    }

    clearError();
    setFeedbackError("");
    setIsSendingFeedback(true);

    try {
      const result = await sendFeedback(context?.token, { feedbackText });

      if (result) {
        setShowThankYou(true);
        setFeedbackText("");
        setShowFeedback(false);
      } else {
        setFeedbackError(t("feedback_send_failed"));
      }
    } catch (err) {
      console.error("handleSaveFeedback, error", err?.message);
      setFeedbackError(t("feedback_send_failed"));
    } finally {
      setIsSendingFeedback(false);
    }
  };

  const handleOpenFeedback = () => {
    setFeedbackError("");
    setShowFeedback(true);
  };

  return (
    <footer className="w3-container w3-theme-l3 w3-center w3-padding-small app-footer">
      <div className="w3-row app-footer-row">
        <div className="w3-col s3 w3-mobile app-footer-logo-column">
          <img src={eulogo} alt="EU logo" className="eu-logo" />
        </div>
        <div className="app-footer-mobile-actions">
          <a
            className="app-footer-link app-footer-mobile-link"
            href={impressum}
            target="_blank"
            rel="noreferrer"
          >
            {t("imprint")}
          </a>
          <a
            className="app-footer-link app-footer-mobile-link"
            href={dataProtection}
            target="_blank"
            rel="noreferrer"
          >
            {t("data_protection")}
          </a>
          {context?.userId > 0 && (
            <label
              className="label-link app-footer-link app-footer-mobile-link"
              onClick={handleOpenFeedback}
            >
              {t("feedback")}
            </label>
          )}
          <label
            className="label-link app-footer-link app-footer-mobile-link"
            onClick={() => setShowChanges(true)}
          >
            v.{context?.version}
          </label>
        </div>
        <div className="w3-col s6 w3-mobile w3-center app-footer-links-column">
          <div className="flex-aligned-items-centered app-footer-links">
            <a
              className="w3-mobile w3-margin-left w3-margin-right app-footer-link"
              href={impressum}
              target="_blank"
              rel="noreferrer"
            >
              {t("imprint")}
            </a>
            <a
              className="w3-mobile w3-margin-left app-footer-link"
              href={dataProtection}
              target="_blank"
              rel="noreferrer"
            >
              {t("data_protection")}
            </a>
            { context?.userId > 0 &&
              <label
                className="w3-container w3-mobile label-link app-footer-link"
                onClick={handleOpenFeedback}
              >
                { t("feedback") }
              </label>
            }
          </div>
        </div>
        <div className="w3-col s3 w3-mobile app-footer-version-column">
          <div className="flex-aligned-items-centered app-footer-version">
            <label
              className="w3-container w3-mobile label-link app-footer-link"
              onClick={() => setShowChanges(true)}
            >
              v.{context?.version}
            </label>
          </div>
        </div>
      </div>
      {showChanges && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header feedback-modal-header-right">
              <h2>{t("changes")}</h2>
              <FontAwesomeIcon
                icon={faXmark}
                className="modal-close"
                onClick={() => setShowChanges(false)}
              />
            </header>
            <div className="feedback-modal-body">
              <label>{context?.description}</label>
            </div>
          </div>
        </div>
      )}
      {showFeedback && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>{t("feedback")}</h2>
              <FontAwesomeIcon
                icon={faXmark}
                className="modal-close"
                onClick={() => setShowFeedback(false)}
              />
            </header>
            <textarea
              value={feedbackText}
              onChange={(e) => {
                if (feedbackError) {
                  setFeedbackError("");
                }
                setFeedbackText(e.target.value);
              }}
              className="feedback-textarea"
            />
            {feedbackError && (<p className="feedback-error">{feedbackError}</p>)}
            <div className="feedback-modal-buttons">
              <button
                onClick={handleSaveFeedback}
                className="w3-btn w3-round-xlarge w3-theme-d5"
                disabled={isSendingFeedback || !feedbackText.trim()}
              >
                {t("save")}
              </button>
            </div>
          </div>
        </div>
      )}
      {showThankYou && (
        <div className="thank-you-modal">
          <div className="thank-you-modal-content">
            <header className="thank-you-modal-header">
              <h2>{t("thank_you")}</h2>
              <FontAwesomeIcon
                icon={faXmark}
                className="modal-close"
                onClick={() => setShowThankYou(false)}  // **Änderung**
              />
            </header>
            <p>{t("your_feedback_sent")}</p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default AppFooter;
